<template>
  <v-layout row>
    <v-flex xs12>

      <div>
        <v-btn color="primary" @click="tabindex = 0">Event Log</v-btn>
        <v-btn color="primary" @click="tabindex = 1">Current Sessions</v-btn>
      </div>

      <template v-if="tabindex == 0">
        <!--<v-card>-->

          <v-timeline dense class="scrollable">
            <v-slide-x-reverse-transition
              group
              hide-on-leave
            >
              <v-timeline-item
                v-for="(message, index) in logs"
                :key="message.d"
                small
                fill-dot
                color="primary"
              >
                <v-alert
                  :value="true"
                  :color="boxColor(message.el)"
                >
                   <span>{{ message.un }} | {{ message.ip }} | {{ message.d | moment("MMMM Do YYYY, h:mma")
                }}</span><br>
                  <span>{{message.a}} | {{ message.c }} | {{ message.sc }}</span><br>
                  <div> {{ message.m }} | {{ message.x }}.</div>
                </v-alert>
              </v-timeline-item>
            </v-slide-x-reverse-transition>
          </v-timeline>

          <!--<ul class="scrollable list-group" v-chat-scroll="{always: false, smooth: true}">-->
            <!--&lt;!&ndash; <v-list two-line class="scrollable" v-chat-scroll="{always: false, smooth: true}"> &ndash;&gt;-->
            <!--<template v-for="(message, index) in logs">-->
              <!--<li class="list-group-item">-->
                <!--<v-card color="blue-grey darken-2" class="white&#45;&#45;text">-->
                  <!--<v-card-title>-->
                    <!--<div>-->
              <!--<span>{{ message.un }} | {{ message.ip }} | {{ message.d | moment("MMMM Do YYYY, h:mma")-->
                <!--}}</span><br>-->
                      <!--<span>{{message.a}} | {{ message.c }} | {{ message.sc }}</span><br>-->
                      <!--<div> {{ message.m }} | {{ message.x }}.</div>-->
                    <!--</div>-->
                  <!--</v-card-title>-->
                <!--</v-card>-->
              <!--</li>-->
            <!--</template>-->
          <!--</ul>-->
          <!--&lt;!&ndash; </v-list> &ndash;&gt;-->

        <!--</v-card>-->
      </template>
      <template v-if="tabindex == 1">

        <v-data-table
          :headers="headers"
          :items="sessions"
          hide-actions
          class="elevation-1"
        >
          <template slot="items" slot-scope="props">
            <td>{{ props.item.uid.local.email }}</td>
            <!--<td class="text-xs-right">{{ props.item }}</td>-->
            <td>
              <template v-for="(item, index) in props.item.apps">
              <v-chip v-if="index.startsWith('analyzer')" color="blue lighten-2">
              <template>
              <strong>{{ index }}</strong>&nbsp;
              </template>
              <template v-if="!smallscreen">
              <span>{{ item.current_activity }}</span>&nbsp;
              <span>{{ item.open_job_id }}</span>&nbsp;
              </template>
              </v-chip>
              <v-chip v-else-if="index.startsWith('entrysuite')" color="blue darken-1">
              <template>
              <strong>{{ index }}</strong>&nbsp;
              </template>
              <template v-if="!smallscreen">
              <span>{{ item.current_activity }}</span>&nbsp;
              <span>{{ item.open_job_id }}</span>&nbsp;
              </template>
              </v-chip>
              <v-chip v-else-if="index === 'VSS WebPanel'" color="blue darken-3">
              <template>
              <strong>{{ index }}</strong>&nbsp;
              </template>
              <template v-if="!smallscreen">
              <span>{{ item.current_activity }}</span>&nbsp;
              <span>{{ item.open_job_id }}</span>&nbsp;
              </template>
              </v-chip>
              </template>
            </td>
          </template>
        </v-data-table>
      </template>


    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    name: 'app',
    data() {
      return {
        active: null,
        messages: [],
        tabindex: 0,
        smallscreen: false,
        headers: [
          {text: 'User', align: 'left', sortable: false, value: 'email'},
          {text: "Activity", align: 'left', sortable: false}
        ]
      }
    },
    methods: {
      handleMessage(msg) {
        this.messages.push(JSON.parse(msg))
      },
      handleResize(event) {
        if (document.documentElement.clientWidth > 600) {
          this.smallscreen = false;
        } else {
          this.smallscreen = true;
        }
      },
      boxColor: function(eventlevel) {
        if(eventlevel > 50){
          return "accent"
        }else{
          return "info"
        }

      }
    },
    created() {
      this.$store.dispatch('GET_LATEST_LOGS')
      //Socket.$on("message", this.handleMessage)
    },
    computed: {
      logs: function () {
        return this.$store.getters.logs;
      },
      sessions: function () {
        return this.$store.getters.sessions;
      }
    },
    beforeDestroy() {
      //Socket.$off("message", this.handleMessage)
    },
    mounted: function() {
      window.addEventListener('resize', this.handleResize);
      console.log("MOUNTED");
    }
  }
</script>

<style>
  .scrollable {
    overflow: hidden;
    overflow-y: auto;
    height: 70vh;
    display: flex;
    flex-direction: column-reverse;

  }

  .scrollside {
    overflow-x: scroll;
    -webkit-flex: 1; /* Safari 6.1+ */
    -ms-flex: 1; /* IE 10 */
    flex: 1;
  }

  li {
    list-style-type: none;
  }

</style>



// WEBPACK FOOTER //
// src/pages/admin/Overview.vue